import React from 'react';
import { Spin } from 'antd';

interface ToolStatusIndicatorProps {
  isToolRunning: boolean;
  toolName: string;
  toolStatus: string;
}

const ToolStatusIndicator: React.FC<ToolStatusIndicatorProps> = ({
  isToolRunning,
  toolName,
  toolStatus
}) => {
  if (!isToolRunning) return null;

  return (
    <div className="tool-running-indicator">
      <Spin size="small" style={{ marginRight: '10px' }} />
      <div style={{ display: 'flex', flexDirection: 'column', 'color':'--var(--text-color)' }}>
        <span>Running tool: {toolName.replace(/_/g, ' ')}...</span>
        {toolStatus && (
          <span style={{ 
            fontSize: '12px', 
            color: '#888', 
            marginTop: '4px',
            fontStyle: 'italic'
          }}>
            {toolStatus.replace(/[\n\r]+/g, ' ').trim()}
          </span>
        )}
      </div>
    </div>
  );
};

export default ToolStatusIndicator;
